const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Migrate webhooks', () => {
  describe('preview migrating a single webhook by id', () => {
    const mock = loadRecordedMock(
      'migrate_webhooks_single_preview.json'
    );

    it(`should return one webhook`, (done) => {
      migratortronApi.post(
        'migrate/webhooks?single',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.webhooks?.migratortron?.totalCount).to.equal(1);
          done();
        }
      );
    });
  });

  describe('migrate a single webhook by id', () => {
    const mock = loadRecordedMock(
      'migrate_webhooks_commit_single.json'
    );

    it(`should create one webhook`, (done) => {
      migratortronApi.post(
        'migrate/webhooks/commit?single',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.webhooks?.migratortron?.totalCount).to.equal(1);
          expect(body?.webhooksResult.created).to.equal(1);
          expect(body?.webhooksResult.updated).to.equal(0);
          expect(body?.webhooksResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single webhook by id', () => {
    const mock = loadRecordedMock(
      'migrate_webhooks_commit_single_repeat.json'
    );

    it(`should return one webhook`, (done) => {
      migratortronApi.post(
        'migrate/webhooks/commit?single&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('webhooks.*.totalCount', body)).to.equal(1);
          expect(jpath('existing.*.totalCount', body)).to.equal(2);
          expect(jpath('webhooksToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.webhooksResult.created).to.equal(0);
          expect(body?.webhooksResult.updated).to.equal(0);
          expect(body?.webhooksResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview migrating a single webhook by name', () => {
    const mock = loadRecordedMock('migrate_webhooks_name_preview.json');

    it(`should return one webhook`, (done) => {
      migratortronApi.post(
        'migrate/webhooks?name',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.webhooks?.migratortron?.totalCount).to.equal(2);
          done();
        }
      );
    });
  });

  describe('migrate a single webhook by name', () => {
    const mock = loadRecordedMock('migrate_webhooks_commit_name.json');

    it(`should create one webhook`, (done) => {
      migratortronApi.post(
        'migrate/webhooks/commit?name',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.webhooks?.migratortron?.totalCount).to.equal(2);
          expect(body?.webhooksResult.created).to.equal(1);
          expect(body?.webhooksResult.updated).to.equal(0);
          expect(body?.webhooksResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single webhook by name', () => {
    const mock = loadRecordedMock(
      'migrate_webhooks_commit_name_repeat.json'
    );

    it(`should return one webhook`, (done) => {
      migratortronApi.post(
        'migrate/webhooks/commit?name&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('webhooks.*.totalCount', body)).to.equal(2);
          expect(jpath('existing.*.totalCount', body)).to.equal(3); // this is wonky = should be 2
          expect(jpath('webhooksToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.webhooksResult.created).to.equal(0);
          expect(body?.webhooksResult.updated).to.equal(0);
          expect(body?.webhooksResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
